import { useTranslate } from "@tolgee/react";
import React from "react";
import { Loading } from "src/components";

function LoadingPage() {
  const { t } = useTranslate();
  const asideMenu = document.querySelector("aside");
  let menuWidth = 77;
  if (asideMenu?.offsetWidth) menuWidth = asideMenu.offsetWidth;
  return (
    <div
      style={{
        height: "calc(100vh - 300px)",
        width: `calc(100vw - ${menuWidth}px)`,
      }}
    >
      <Loading
        active
        loadingText={t({
          key: "pages.loadingPage.loadingText",
          defaultValue: "Loading User Data",
        })}
      />
    </div>
  );
}

export default LoadingPage;
